import { createFileRoute } from "@tanstack/react-router";

import { Income } from "~/components/feature/results/components/ResultsIncome";

export const Route = createFileRoute("/_app/dashboard/results/income/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Income />;
}
